import React from 'react';

import css from './BannerMessageHorizontal.module.scss';

interface Props {
  header: string;
  description: string;
  icon?: React.ReactNode;
}

const BannerMessageHorizontal = ({ header, description, icon }: Props) => {
  return (
    <div className={css.bannerContainer}>
      <div className={css.logoContainer}>
        {icon || <img src={'../../static/warning.svg'} />}
      </div>
      <div>
        <div className={css.headerContainer}>
          <h3 data-testid="banner-header" className={css.header}>
            {header}
          </h3>
        </div>
        <div className={css.description}>{description}</div>
      </div>
    </div>
  );
};

export default BannerMessageHorizontal;
